import React from 'react'
import { DINING_METHOD } from '@common'

const CartSummary = ({ assistantInfo, originAmount, totalAmount, promoDiscount = 0, eligiblePromos = [] }) => {
    const getDiningMethodText = () => {
        if (assistantInfo?.diningMethod === DINING_METHOD.DineIn) {
            return 'Dine In'
        } else {
            return 'Takeaway'
        }
    }

    const hasPromoInfo = promoDiscount > 0 || eligiblePromos.length > 0
    const showSubtotal = hasPromoInfo && originAmount !== null && originAmount !== totalAmount

    return (
        <div className="border-top border-2 border-secondary pt-4" style={{ flex: '0 0 auto' }}>
            {/* Promo section */}
            {hasPromoInfo && (
                <div className="mb-3" style={{ fontSize: '1.5rem' }}>
                    {showSubtotal && (
                        <div className="d-flex justify-content-between align-items-center">
                            <span>Subtotal</span>
                            <span>${originAmount?.toFixed(2)}</span>
                        </div>
                    )}
                    {promoDiscount > 0 && (
                        <div className="d-flex justify-content-between align-items-center">
                            <span>Promo Discount</span>
                            <span className="text-danger">-${promoDiscount.toFixed(2)}</span>
                        </div>
                    )}
                    {/* {eligiblePromos.length > 0 && (
                        <div className="mt-2">
                            <div className="fw-bold mb-1">Eligible promotions</div>
                            {eligiblePromos.map(promo => (
                                <div key={promo.promoType} className="d-flex justify-content-between align-items-center">
                                    <span>{promo.displayName}</span>
                                    <i className="bx bx-sm bxs-check-circle text-primary"></i>
                                </div>
                            ))}
                        </div>
                    )} */}
                </div>
            )}

            {/* Total and dining method */}
            <div className="d-flex justify-content-between">
                <div className="text-start">
                    <div className="fw-bold" style={{ fontSize: '2.5rem' }}>
                        {getDiningMethodText()}
                    </div>
                </div>
                <div className="text-end">
                    <div className="fw-bold" style={{ fontSize: '2.5rem' }}>
                        Total: {`$${totalAmount?.toFixed(2) || '0.00'}`}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartSummary
